(()=>{
const cartSelector='[data-livpack-express-count]';
const quoteSelector='[data-livpack-quote-count]';
const quoteCookieKey='livpack_storeify_quote_items';
let cartVersion=0;
let pendingQuoteItem=null;
let lastSavedQuoteSignature=null;

function readQuoteItems(){
  try{
    const prefix=quoteCookieKey+'=';
    const entry=document.cookie.split(';').map(part=>part.trim()).find(part=>part.startsWith(prefix));
    if(!entry)return [];
    const value=JSON.parse(decodeURIComponent(entry.slice(prefix.length)));
    return Array.isArray(value)?[...new Set(value.map(String))]:[];
  }catch(e){return [];}
}
function paintQuoteCount(items=readQuoteItems()){
  const value=String(items.length);
  document.querySelectorAll(quoteSelector).forEach(node=>{if(node.textContent!==value)node.textContent=value;});
}
function saveQuoteItems(items){
  const unique=[...new Set(items.map(String))];
  const signature=JSON.stringify(unique);
  if(signature===lastSavedQuoteSignature){paintQuoteCount(unique);return;}
  lastSavedQuoteSignature=signature;
  try{document.cookie=quoteCookieKey+'='+encodeURIComponent(signature)+'; Path=/; Max-Age=2592000; SameSite=Lax';}catch(e){}
  paintQuoteCount(unique);
}
function selectedQuoteKey(target){
  const group=target&&target.closest('.ify-quote-group[data-targetid]');
  let productId=group&&group.dataset.targetid;
  if(!productId){
    const script=document.querySelector('script[id^="ify_script_item_"]');
    if(script)productId=script.id.replace('ify_script_item_','');
  }
  if(!productId){
    const productIdInput=document.querySelector('input[name="product-id"]');
    if(productIdInput&&productIdInput.value)productId=productIdInput.value;
  }
  const variantInput=document.querySelector('input.product-variant-id, input[name="id"]');
  const variantId=variantInput&&variantInput.value;
  const optionValues=[...document.querySelectorAll('variant-selects select, select[name^="options["]')].map(input=>input.value).filter(Boolean);
  return String(productId||location.pathname)+'::'+String(variantId||optionValues.join('|')||'default');
}
function syncQuoteList(){
  if(!location.pathname.includes('/apps/request-a-quote/index'))return;
  const wrapper=document.querySelector('#storeify_form_quote');
  if(!wrapper)return;
  const rows=[...wrapper.querySelectorAll('tr')].filter(row=>row.querySelector('a[href*="/products/"]'));
  const empty=/Votre liste est vide|Your quote is currently empty|Your list is empty|قائمتكم خالية/i.test(wrapper.textContent||'');
  if(!rows.length&&!empty)return;
  const keys=rows.map(row=>{
    const link=row.querySelector('a[href*="/products/"]');
    try{
      const url=new URL(link.href,location.href);
      return url.searchParams.get('variant')||url.pathname;
    }catch(e){return (link.textContent||'').trim();}
  });
  saveQuoteItems(keys);
}
function isVisible(node){
  if(!node)return false;
  const style=window.getComputedStyle(node);
  return style.display!=='none'&&style.visibility!=='hidden'&&node.getClientRects().length>0;
}
function syncStoreifyModal(){
  const success=document.querySelector('#storeify-mes-modal');
  const successVisible=isVisible(success)&&/(ajouté avec succès|added successfully)/i.test(success.textContent||'');
  if(pendingQuoteItem&&successVisible){
    saveQuoteItems([...readQuoteItems(),pendingQuoteItem]);
    pendingQuoteItem=null;
    return;
  }
  if(!pendingQuoteItem&&!successVisible){
    const chooser=document.querySelector('#storeify-chooseproduct-modal');
    if(isVisible(chooser))pendingQuoteItem=selectedQuoteKey(chooser);
  }
}
function refreshCart(){
  const current=++cartVersion;
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  window.fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'}).then(response=>{
    if(!response.ok)return null;
    return response.json();
  }).then(cart=>{
    if(!cart||current!==cartVersion)return;
    const count=Array.isArray(cart.items)?cart.items.length:0;
    document.querySelectorAll(cartSelector).forEach(node=>{const value=String(count);if(node.textContent!==value)node.textContent=value;});
  }).catch(()=>{});
}
const originalFetch=window.fetch;
window.fetch=function(input,init){
  let cartMutation=false;
  try{
    const href=input instanceof Request?input.url:String(input);
    const url=new URL(href,location.href);
    cartMutation=/^\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
  }catch(e){}
  const result=originalFetch.apply(this,arguments);
  if(cartMutation&&result&&typeof result.then==='function')result.then(response=>{if(response.ok)refreshCart();}).catch(()=>{});
  return result;
};

if(location.pathname.includes('/apps/request-a-quote/index')&&document.body){
  const listObserver=new MutationObserver(syncQuoteList);
  listObserver.observe(document.body,{childList:true,subtree:true});
}else if(document.body){
  const modalObserver=new MutationObserver(syncStoreifyModal);
  modalObserver.observe(document.body,{childList:true,subtree:true,characterData:true});
}
window.addEventListener('pageshow',()=>{paintQuoteCount();refreshCart();syncQuoteList();});
document.addEventListener('shopify:section:load',()=>{paintQuoteCount();refreshCart();syncQuoteList();});
paintQuoteCount();
refreshCart();
syncQuoteList();
})();